export default "__VITE_ASSET__8da68102__"